import { maxLength, pattern, required } from '@rxweb/reactive-form-validators';

export class VerifyAccountModel {
    @required({ message: '' })
    @maxLength({
        value: 1,
        message: ""
    })
    @pattern({
        expression: {
            alphaNumeric: /^[0-9]*$/,
        },
        message: '',
    })
    firstCode: string;
    
    @required({ message: '' })
    @maxLength({
        value: 1,
        message: ""
    })
    @pattern({
        expression: {
            alphaNumeric: /^[0-9]*$/,
        },
        message: '',
    })
    secondCode: string;
    
    @required({ message: '' })
    @maxLength({
        value: 1,
        message: ""
    })
    @pattern({
        expression: {
            alphaNumeric: /^[0-9]*$/,
        },
        message: '',
    })
    thirdCode: string;
    
    @required({ message: '' })
    @maxLength({
        value: 1,
        message: ""
    })
    @pattern({
        expression: {
            alphaNumeric: /^[0-9]*$/,
        },
        message: '',
    })
    fourthCode: string;
}